// extracted by mini-css-extract-plugin
export default {"notFoundPage":"not-found-page_notFoundPage__uFmFA","messageWrapper":"not-found-page_messageWrapper__Ht3WP","notFoundMessage":"not-found-page_notFoundMessage__kWxIJ"};